// extracted by mini-css-extract-plugin
export default {"dropdownWrapper":"BreadcrumbDropdown_dropdownWrapper__EeTlm","dropdownMenu":"BreadcrumbDropdown_dropdownMenu__skZnE","dropdownItem":"BreadcrumbDropdown_dropdownItem__S3Lzr"};